import Form from "react-bootstrap/Form";
import "./CustomCheckExample.css";

function CustomRadioExample(props) {
  return (
    <Form>
      <Form.Check
        type="radio"
        id={props.id}
        label={props.label}
        name={props.name}
        checked={props.checked}
        onClick={props.onClick} 
        className="custom-checkbox"
        disabled={props.disabled} 
      />
    </Form>
  );
}

export default CustomRadioExample;
